import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import Image, {
  Props as ImageProps
} from '../../Atoms/Image';

export interface SlideProps {
  image: ImageProps;
}
export interface Props {
  slides: SlideProps[];
  className?: string;
}

function Slide({ image }: SlideProps) {
  return (
    <Image
      {...image}
      className="h-52 w-72 rounded-xl object-cover object-center"
    />
  );
}

function ImageCarousel({ slides, className }: Props) {
  return (
    <div
      className={classNames([
        'w-full overflow-hidden',
        className
      ])}
    >
      <div className="mx-auto w-full max-w-screen-2xl px-7">
        <Swiper
          slidesPerView="auto"
          slidesPerGroup={1}
          spaceBetween={30}
          className="!overflow-visible !py-10"
          mousewheel
          grabCursor
          pagination={{
            dynamicBullets: true,
            clickable: true
          }}
          modules={[Pagination]}
        >
          {slides.map((slide) => (
            <SwiperSlide
              className="!w-auto"
              key={slides.indexOf(slide)}
            >
              <Slide {...slide} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ImageCarousel;
